import { inject, Injectable } from '@angular/core'

import { takeUntil } from 'rxjs'

import { WhiteLabelSettings } from '@ti/contracts'
import { ApiService } from '@ti/core/api'
import { AuthSession } from '@ti/core/auth/services'
import { WhiteLabelSettingsProvider } from '@ti/core/common/services'
import { CONFIG } from '@ti/core/contracts/config'

@Injectable()
export class FleetWhiteLabelSettingsProvider extends WhiteLabelSettingsProvider {
  protected readonly api = inject(ApiService)
  protected readonly authSession = inject(AuthSession)
  protected readonly config = inject(CONFIG)

  protected DEFAULT_SETTINGS: WhiteLabelSettings = {
    name: 'Fleet App',
    domain: '',
    emailSenderDomain: '',
    logoLargeUrl: '',
    logoCompactUrl: '',
    logoSquareHighResUrl: '',
    googleMapsKey: '',
  }

  public constructor() {
    super()

    this.authSession.state.onSignedIn$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.refresh())
  }

  protected override async getSettings() {
    let settings: WhiteLabelSettings | undefined
    try {
      const loggedIn = await this.authSession.isLoggedIn()
      if (loggedIn) {
        settings = await this.api.fleet.whiteLabel.getCurrentUserSettings()
      } else if (
        this.config.envType !== 'local' &&
        this.config.fleetDefaultDomain !== window.location.hostname
      ) {
        settings = await this.api.fleet.whiteLabel.getSettingsByDomainName(window.location.hostname)
      }
    } catch (e) {
      console.error(e)
    }
    return settings || this.DEFAULT_SETTINGS
  }
}
